import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Button, Typography, Box } from '@mui/material';
import { UIContext } from '../../context/UIContext';
import { ReactComponent as WarningIcon } from '../../img/icons/warning.svg';
import { ReactComponent as WarningIconWhite } from '../../img/icons/warning-white.svg';
import { BACK_OFFICE_LINK_KEY } from '../../localStorageKeys';
import usePageTitle from '../../helperHooks/usePageTitle';

const NoSteps = () => {
  const { t } = useTranslation();
  const { colorMode } = useContext(UIContext);

  usePageTitle('nav.noSteps');

  return (
    <Card
      variant="outlined"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        paddingX: { xs: 3, sm: 10 },
        paddingY: { xs: 10, sm: 10 },
        textAlign: 'center',
        alignItems: 'center',
      }}
    >
      {colorMode === 'light' ? <WarningIcon /> : <WarningIconWhite />}
      <Box sx={{ marginTop: '2rem' }}>
        <Typography variant="h3">{t('screens.noSteps.header')}</Typography>
        <Typography variant="body1">{t('screens.noSteps.description')}</Typography>
        <Button
          variant="contained"
          component="a"
          href={localStorage.getItem(BACK_OFFICE_LINK_KEY)}
          sx={{ marginTop: '2em' }}
        >
          {t('screens.noSteps.button')}
        </Button>
      </Box>
    </Card>
  );
};

export default NoSteps;
